// src/data/ProjectsFeaturedData.js
import { TechIcons } from "../components/common/TechIcons";

const featuredProjects = [
  // {
  //   id: "australia-wildfire-analysis",
  //   year: 2025,
  //   projectName: "Australia Wildfire Activity Analysis",
  //   stat: "15 yrs · 7 regions · 1M+ detections",
  //   description:
  //     "Exploratory analysis of 15 years of NASA satellite fire data across 7 Australian regions to identify risk patterns, seasonal trends, and regional concentration.",
  //   technologies: [TechIcons.Python, TechIcons.Pandas, TechIcons.Plotly],
  //   highlights: [
  //     "Identified 2019–20 Black Summer as a structural break, not a gradual trend.",
  //     "Quantified regional risk concentration — two regions account for ~58% of all fire detections.",
  //     "Built interactive Dash dashboard for region and year exploration.",
  //   ],
  //   caseStudyPath: "/projects/australia-wildfire-analysis",
  //   repoUrl: "https://github.com/abranco0403/australia-wildfire-analysis",
  //   dashboardUrl: "https://aus-wildfire-analysis.netlify.app",
  // },
  {
    id: "resume-retail-ops-dashboard",
    year: 2025,
    projectName: "Retail Operations Performance Dashboard",
    stat: "12 KPIs · weekly cadence · 2 channels",
    description:
      "Power BI dashboard to track sales + operational KPIs across in-store and ecommerce channels for weekly decision support.",
    technologies: [TechIcons.PowerBI, TechIcons.SQL, TechIcons.Excel],
    highlights: [
      "Replaced ad-hoc spreadsheets with a consistent weekly reporting framework used by leadership.",
      "Built 12 DAX measures covering revenue trend, channel mix, and inventory turnover.",
      "Enabled drill-down by channel and category — reduced time to insight for weekly reviews.",
    ],
    caseStudyPath: "/projects/retail-ops-dashboard",
    repoUrl:
      "https://github.com/abranco0403/data-analytics-portfolio/tree/main/retail-operations-performance-dashboard",
  },
  {
    id: "retail-pricing-optimization",
    year: 2025,
    projectName: "Retail Pricing Optimization Analysis",
    stat: "9,994 transactions · $234K margin opportunity identified",
    description:
      "End-to-end pricing analysis of a US retail dataset to identify margin leaks, quantify the impact of discounting behavior, and deliver dollar-quantified recommendations by category.",
    technologies: [TechIcons.SQL, TechIcons.Excel, TechIcons.PowerBI],
    highlights: [
      "Identified discount cliff at 20% — transactions above this threshold average a net loss across all categories.",
      "Found Tables sub-category loses $17,725 despite $207K in revenue due to aggressive discounting vs peers.",
      "Quantified $234K addressable profit opportunity across 4 prioritized recommendations.",
    ],
    caseStudyPath: "/projects/retail-pricing-optimization",
    repoUrl: "https://github.com/abranco0403/retail-pricing-optimization",
  },
  {
    id: "resume-customer-rfm-segmentation",
    year: 2025,
    projectName: "Customer Retention & Segmentation (RFM)",
    stat: "4 segments · 3 retention actions identified",
    description:
      "Segmented customers with RFM to identify high-value and at-risk cohorts and support retention planning.",
    technologies: [TechIcons.Python, TechIcons.Pandas, TechIcons.Excel],
    highlights: [
      "Segmented customer base into 4 behavioral cohorts using Recency, Frequency, and Monetary scoring.",
      "Identified at-risk high-value customers — the cohort most likely to respond to retention offers.",
      "Translated segment findings into 3 concrete retention actions with business rationale.",
    ],
    caseStudyPath: "/projects/customer-rfm-segmentation",
    repoUrl:
      "https://github.com/abranco0403/data-analytics-portfolio/tree/main/customer-retention-segmentation-rfm",
  },
  // {
  //   id: "healthcare-revenue-cycle-analytics",
  //   year: 2025,
  //   projectName: "Healthcare Revenue Cycle Analytics Dashboard",
  //   stat: "$2.4M AR monitored · 3 denial drivers",
  //   description:
  //     "Power BI dashboard for denial rate, AR aging, payer mix, and revenue leakage signals to prioritize actions.",
  //   technologies: [TechIcons.PowerBI, TechIcons.Excel],
  //   highlights: [
  //     "Standardized revenue cycle KPIs (denials, aging, at-risk).",
  //     "Modeled claims-style data for reporting.",
  //     "Enabled payer/segment drilldowns to isolate drivers.",
  //   ],
  //   caseStudyPath: "/projects/healthcare-revenue-cycle",
  //   repoUrl:
  //     "https://github.com/abranco0403/data-analytics-portfolio/tree/main/healthcare-revenue-cycle-analytics",
  // },
  // {
  //   id: "personal-portfolio-react-tailwind",
  //   year: 2024,
  //   projectName: "Personal Portfolio Website (React + Tailwind)",
  //   stat: "3 sections · sub-2s load · 100% accessible",
  //   description:
  //     "Recruiter-first portfolio built for quick scanning, clear hierarchy, and strong technical credibility.",
  //   technologies: [TechIcons.React, TechIcons.Tailwind, TechIcons.Netlify],
  //   highlights: [
  //     "Projects structured like resume evaluation.",
  //     "Clean navigation and consistent UI patterns.",
  //     "Deployed with performance + accessibility in mind.",
  //   ],
  //   caseStudyPath: "/projects/portfolio-website",
  //   repoUrl: "https://github.com/abranco0403/Personal-Portfolio",
  // },
];

export default featuredProjects;